import { HandleSSOSubmitResult } from "@faire/deprecated-retailer-visitor-shared/components/AppSignIn/components/SSOView";
import { View } from "@faire/deprecated-retailer-visitor-shared/components/AppSignIn/components/View";
import { AppleLoginButton } from "@faire/deprecated-retailer-visitor-shared/components/SocialSignOnButtons/AppleLoginButton";
import { GoogleLoginButtonV2 } from "@faire/deprecated-retailer-visitor-shared/components/SocialSignOnButtons/GoogleLoginButtonV2";
import { OktaLoginButton } from "@faire/deprecated-retailer-visitor-shared/components/SocialSignOnButtons/OktaLoginButton";
import { AppModalEnv } from "@faire/retailer-visitor-shared/components/App/AppModals/types";
import { ILoginResponse } from "@faire/web-api--source/indigofair/data/ILoginResponse";
import { ISignUpSuggestions } from "@faire/web-api--source/indigofair/data/ISignUpSuggestions";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { Spacer } from "@faire/web/slate/spacing";
import React, { FC } from "react";

interface IProps {
  provider: SocialSignOnProvider;
  onFinish: (result: HandleSSOSubmitResult) => void;
  onLogin: (user: IUser) => void;
  onConfirmPassword: (signUpSuggestions?: ISignUpSuggestions) => void;
  sourceId: string;
  appModalEnv: AppModalEnv;
}

export const SocialLoginButton: FC<IProps> = ({
  provider,
  onFinish,
  onLogin,
  onConfirmPassword,
  sourceId,
  appModalEnv,
}) => {
  const onSignIn = (user: IUser) => {
    onLogin(user);
    onFinish({
      nextView: View.LOADING,
      user,
    });
  };
  //TODO: ADD NEW MFA UI FOR SSO
  const onSelectMFA = (mfaOptions: ILoginResponse.IMfaOption[]) => {
    onFinish({
      nextView: View.SELECT_MFA_OPTION,
      mfaOptions,
    });
  };
  const onMFA = (mfaDescription: string, mfaTitle: string) => {
    onFinish({
      nextView: View.ENTER_MFA,
      mfaTitle,
      mfaDescription,
    });
  };

  switch (provider) {
    case SocialSignOnProvider.GOOGLE:
      return (
        <>
          <Spacer height="3x" />
          <GoogleLoginButtonV2
            onSignIn={onSignIn}
            onMFA={onMFA}
            onSelectMFA={onSelectMFA}
            onConfirmPassword={onConfirmPassword}
            sourceId={sourceId}
            isOnSignIn
            appModalEnv={appModalEnv}
          />
        </>
      );
    case SocialSignOnProvider.APPLE:
      return (
        <>
          <Spacer height="3x" />
          <AppleLoginButton
            onSignIn={onSignIn}
            onMFA={onMFA}
            onSelectMFA={onSelectMFA}
            onConfirmPassword={onConfirmPassword}
            sourceId={sourceId}
            isOnSignIn
            appModalEnv={appModalEnv}
          />
        </>
      );
    case SocialSignOnProvider.OKTA:
      return (
        <>
          <Spacer height="3x" />
          <OktaLoginButton
            onSignIn={onSignIn}
            onMFA={onMFA}
            onSelectMFA={onSelectMFA}
            onConfirmPassword={onConfirmPassword}
            sourceId={sourceId}
            isOnSignIn
            appModalEnv={appModalEnv}
          />
        </>
      );
    default:
      return null;
  }
};
